module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTPro-Roman.346fef9b.otf";